import { withRouter } from 'react-router';
import { useHistory } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import '../../../../Utility/Public/css/theme.css';
import PropTypes from 'prop-types';
import moment from 'moment';
// import { css } from 'emotion';
// import ScrollToBottom from 'react-scroll-to-bottom';

// const ROOT_CSS = css({
// 	height: 600,
// 	width: 400
//   });
  

const Chatpanel = (props) => {
	return (
		
		<div className='chatPanelBoxes'>
			{/* <div className='chapBox'> */}
			<div className='chapBox' style={{ height: '400px', overflow: 'auto' }} onScroll={(e) => props.handleScroll(e)}>
			{/* <ScrollToBottom className={ROOT_CSS}> */}
				<ul ref={props.messageRef}>
					{props.chatHistoryData.map((item, index) => {
						let chatDescription = (item.chat_description).split('\n');
						let botBackColor = "left_align_box"
						if(item.message_type == "to"){
							botBackColor = "right_align_box"
							if(item.followup_by == null){
								botBackColor = "right_align_box_follow_up" 
							}
						}
						return (
							<li key={index} className={`${botBackColor} default_class`}>
								<div className='paraBox'>
									{chatDescription.map((line, index) => (
										<React.Fragment key={index}>
											{line}
											<br />
										</React.Fragment>
									))}
									{item.doc_link != null && item.doc_link != "" ?
										<button type="button" className="downloadiconbtn downloadbtn"  >

											<a href={item.doc_link} target="_blank" className='pdfIcon'>

												<i className="fa fa-file-pdf-o" aria-hidden="true"></i>

											</a>

										</button> : null}

									<span>
										{item.chat_date}
										<br />
										{item.message_type == 'to' && item.followup_by != null ?
											<span>
												Followed up by: {item?.UserDetails?.first_name} {item?.UserDetails?.last_name}
											</span> : null}
									</span>
								</div>
							</li>
						);
					})

					}


				</ul>
				{/* </ScrollToBottom> */}

			</div>
		</div>
	);
}




const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		token: globalState.LoginReducer.token
	};
}


export default withRouter(connect(mapStateToProps)
	(Chatpanel));



